/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */

import { useNavigate } from "react-router-dom";
import React, { useContext, useEffect } from "react";
import { BodyScan, GenderType, preloadFaceScanModel } from "@swan-admin/swan-web-component";
import { UserDetailsContext } from "../../context/userDetails";
import { FACE_SCAN, GENDER_TYPE, JWTToken, SESSION_STORAGE_KEY, THANKYOU_SCREEN } from "../../vars";
import { getLocalStorageData, getSessionStorage, handleCheckSessionStorage, hasNullSessionValue } from "../../utils/util";
import useIsCustom from "../../customHook/useIsCustom";

function BodyScanPage() {
	const navigate = useNavigate();
	const { name, gender, email, scanType, shopDomain, userInfo } = useContext(UserDetailsContext);
	const { height, device } = userInfo;
	const isCustom = useIsCustom();
	const latestToken = getLocalStorageData(JWTToken) || "";

	useEffect(() => {
		handleCheckSessionStorage();
	}, []);

	return (
		<BodyScan
			key={`${name}-${email}-${gender}-${shopDomain}-${scanType}-${device.focalLength}-${device.modelName}-${height.cm}`}
			token={latestToken}
			userDetails={{
				heightInCm: height.cm,
				userName: name,
				email,
				deviceFocalLength: device.focalLength,
				deviceModelName: device.modelName,
				gender: gender === GENDER_TYPE.MALE ? GenderType.Male : GenderType.Female,
				shopDomain,
				scanType,
				callbackUrl: hasNullSessionValue(SESSION_STORAGE_KEY.CALLBACK_URL) ? getSessionStorage(SESSION_STORAGE_KEY.CALLBACK_URL) : null,
				sourceTag: getSessionStorage(SESSION_STORAGE_KEY.SOURCE) ?? "",
			}}
			onUploadStart={() => !isCustom && preloadFaceScanModel()}
			onScanError={(errorDetails) => console.log(errorDetails)}
			onComplete={() => !isCustom && navigate(FACE_SCAN)}
			onRetry={() => console.log("retry")}
			onCustomScanSuccess={() => isCustom && navigate(THANKYOU_SCREEN)}
		/>
	);
}

export default BodyScanPage;
